import ShareLink from './ShareLink';

export default ShareLink;
